import React from 'react';

/**
 * UIDesktopNav - Desktop Navigation organism (top horizontal nav)
 */
const UIDesktopNav = ({
    logo = 'PxlPlygrnd',
    items = [
        { label: 'Home', active: true },
        { label: 'Products', active: false },
        { label: 'About', active: false },
        { label: 'Contact', active: false }
    ],
    showCTA = true,
    ctaLabel = 'Sign Up',
    state = 'default',
    deviceType = 'desktop',
    tokens
}) => {
    const primaryColor = tokens?.colors?.find(c => c.name === 'primary')?.value || '#1677ff';

    // Get typography from tokens
    const headingTypo = tokens?.typography?.find(t => t.name === 'heading')
        || { fontFamily: 'Inter, system-ui, sans-serif', weight: 700, sizes: { mobile: 16, tablet: 18, desktop: 18 } };
    const bodyTypo = tokens?.typography?.find(t => t.name === 'body')
        || { fontFamily: 'Inter, system-ui, sans-serif', weight: 400, sizes: { mobile: 14, tablet: 14, desktop: 14 } };
    const buttonTypo = tokens?.typography?.find(t => t.name === 'button') || bodyTypo;

    const logoSize = headingTypo.sizes?.[deviceType] || headingTypo.sizes?.desktop || 18;
    const navSize = bodyTypo.sizes?.[deviceType] || bodyTypo.sizes?.desktop || 14;
    const baseFontFamily = bodyTypo.fontFamily || 'Inter, system-ui, sans-serif';

    if (state === 'loading') {
        return (
            <div style={{
                width: '100%',
                height: '100%',
                background: '#161b22',
                borderBottom: '1px solid #30363d',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                <div style={{
                    width: 20,
                    height: 20,
                    border: '2px solid #30363d',
                    borderTopColor: primaryColor,
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite'
                }} />
            </div>
        );
    }

    return (
        <div style={{
            width: '100%',
            height: '100%',
            background: '#161b22',
            borderBottom: '1px solid #30363d',
            display: 'flex',
            alignItems: 'center',
            padding: '0 24px',
            gap: 32,
            fontFamily: baseFontFamily
        }}>
            {/* Logo */}
            <span style={{
                fontSize: logoSize,
                fontWeight: headingTypo.weight || 700,
                fontFamily: headingTypo.fontFamily || baseFontFamily,
                color: '#c9d1d9'
            }}>
                {logo}
            </span>

            {/* Nav Items */}
            <div style={{
                display: 'flex',
                gap: 24,
                flex: 1
            }}>
                {items.map((item, index) => (
                    <span
                        key={index}
                        style={{
                            fontSize: navSize,
                            fontWeight: item.active ? 600 : (bodyTypo.weight || 400),
                            color: item.active ? '#c9d1d9' : '#8b949e',
                            cursor: 'pointer',
                            borderBottom: item.active ? `2px solid ${primaryColor}` : '2px solid transparent',
                            paddingBottom: 4
                        }}
                    >
                        {item.label}
                    </span>
                ))}
            </div>

            {/* CTA Button */}
            {showCTA && (
                <div style={{
                    background: primaryColor,
                    color: '#ffffff',
                    padding: '8px 16px',
                    borderRadius: 6,
                    fontSize: navSize,
                    fontWeight: buttonTypo.weight || 500,
                    fontFamily: buttonTypo.fontFamily || baseFontFamily
                }}>
                    {ctaLabel}
                </div>
            )}
        </div>
    );
};

export default UIDesktopNav;
